<template>
    <div id="home-slider-one" class="container-size-fixer">
        <div>
            <h2 id="slider-title">آخرین اخبار و مقالات</h2>
        </div>
        <flickity  v-if="posts"   class="flickity" ref="flickity" :options="flickityOptions">
            <div v-for="post in posts" class="carousel-cell"
                 :style="[post.symbol_image && !post.directional ?{backgroundImage:'url('+$store.state.base_urls.postsUploads+post.symbol_image+')'}:
                 {backgroundImage:'url('+post.symbol_image+')'}]"
                 :key="post">
                <div class="slider-cover"></div>
                <div class="title" v-on:click="$router.push('/article-view/'+post.slug)" >
                    <a :href="'/article-view/'+post.slug" onclick="return false" style="color: white">
                  {{post.title}}
                    </a>
                </div>
                <div class="date-detail details">
                    {{post.created_at}}
                </div>
                <div class="time-detail details">
                    {{post.study_length}}
                     دقیقه
                </div>
            </div>
        </flickity>
        <div v-else-if="loadingMood === false" style="color: white;height: 100%;line-height: 18">
            !موردی یافت نشد
        </div>
        <div v-if="loadingMood">
            <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Flickity from 'vue-flickity'
    import axios from 'axios'
    export default {
        name: "HomeSliderOne",
        components:{
            Flickity
        },
        data () {
            return {
                flickityOptions: {
                    initialIndex: 3,
                    prevNextButtons: true,
                    pageDots: true,
                    wrapAround: false,
                    freeScroll: true,
                    rightToLeft: true,
                    autoPlay:2500,
                    arrowShape: {
                        x0: 30,
                        x1: 45, y1: 20,
                        x2: 55, y2: 20,
                        x3: 40
                    }
                },
                posts:null,
                loadingMood:false
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getLastPosts/15',);
                    this.loadingMood = false;
                    this.posts = response.data.results;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style lang="scss" scoped>
    #space{
        width: 100%;
        height: 10px;
    }
    .container-size-fixer{
        margin: auto;
    }
    .slider-cover{
        border-radius: 10px;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: black;
        opacity: 0.5;
    }
    .title{
        cursor: pointer;
        padding: 0 30px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        right: 0;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
    }
    .details{
        font-family: 'IRANSans';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #ffffff;
    }
    .date-detail{
        position: absolute;
        width: auto;
        height: 25px;
        bottom: 10px;
        right: 10px;
    }
    .time-detail{
        position: absolute;
        width: auto;
        height: 25px;
        bottom: 10px;
        left: 10px;
    }

    #slider-title{
        text-align: right;
        font-size: 36px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #ffffff;
        margin-top: 0;
    }
    .flickity{
        margin-top: 57px;
    }
    #home-slider-one{
        background-color: #162336;
        width: 100%;
        height: 464px;
        padding: 50px 15px 46px 15px;
        margin: auto;
    }
    .carousel-cell{
        background-size:cover ;
        background-repeat: no-repeat;
        position: relative;
        border-radius: 10px;
        margin: 15px;
        width: 370px;
        height: 197px;
    }
    .carousel-cell.is-selected {
        /*002060*/
        /*box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.12);*/
        /*border: solid 2px #fe7063;*/
        /*background-color: rgba(22, 35, 54, 0.9);*/
    }

    .carousel-cell.is-selected > .slider-cover {
        /*opacity: 0.8!important;*/
    }
    .carousel-cell{
        /*border: solid 2px transparent;*/
    }
    .carousel-cell:hover{
        /*box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.12);*/
        /*!*border: solid 2px #fe7063;*!*/
        /*background-color: rgba(22, 35, 54, 0.9);*/
    .slider-cover{
        border: 2px solid #fe7063;
        opacity: 0.8!important;
    }
    }

    .slider-cover{
        transition: all 0.1s ease;
    }

    @media (max-width: 1300px) {
        #home-slider-one{
            padding: 50px 15px 46px 15px;
        }
        #slider-title{
            font-size: 26px;
        }
    }





</style>